import { api } from '../config/api'
import { generateGetApiUrl } from '../utils/urlHelpers'
import { Methods, makeRequest } from './Request'

export const getInitData = (token) => {
  const url = api.routes.data.init
  const headers = { Authorization: token ? `Bearer ${token}` : null }

  return makeRequest(url, Methods.GET, null, headers)
}

export const searchCities = (query) => {
  const url = generateGetApiUrl(api.routes.data.search_cities, { query })

  return makeRequest(url, Methods.GET)
}

export const genericApi = (path) => (data) => {
  const url = generateGetApiUrl(api.routes.data.generic_search + path, data)

  return makeRequest(url, Methods.GET)
}
